import { __awaiter } from "tslib";
import React from 'react';
import ReactDOM from 'react-dom';
import { buildModuleProps } from 'pathfinder/rules-engine/moduleProps';
import getOptimizelyVariant from 'pathfinder/utils/getOptimizelyVariant';
import { insertModuleInContent } from 'pathfinder/modules/shared/utils/insertModuleInContent';
import log from 'pathfinder/utils/log';
const OPTIMIZELY_VARIABLES = {
    EXPERIMENT_ENABLED: 'optimizely_enable_higher_fan_feed_experiment',
    EXPERIMENT_VARIANT: 'optimizely_experiment_higher_fan_feed_variant_name',
};
export const HIGHER_FAN_FEED_VARIANTS = {
    DESKTOP: 'higher-fan-feed-desktop',
    MOBILE_A: 'higher-fan-feed-mobile-a',
    MOBILE_B: 'higher-fan-feed-mobile-b',
};
const insertFanFeedModule = (variant, reactRoot) => {
    if (variant.includes('desktop')) {
        return insertModuleInContent({
            component: reactRoot,
        });
    }
    if (variant.includes('mobile')) {
        const infobox = document.querySelector('.portable-infobox-wrapper');
        infobox.insertAdjacentElement('afterend', reactRoot);
        return {
            type: 'infobox',
            index: 0,
        };
    }
    return null;
};
export const getHigherFanFeedModuleMethods = (moduleConfig) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const isForced = (_a = moduleConfig === null || moduleConfig === void 0 ? void 0 : moduleConfig.internalState) === null || _a === void 0 ? void 0 : _a.forced;
    try {
        const variant = yield getOptimizelyVariant(isForced, OPTIMIZELY_VARIABLES, HIGHER_FAN_FEED_VARIANTS);
        if (!variant) {
            return null;
        }
        const reactRoot = document.createElement('div');
        const adjacentElementData = insertFanFeedModule(variant, reactRoot);
        if (!adjacentElementData) {
            return null;
        }
        const moduleProps = buildModuleProps(moduleConfig, { variant, adjacentElementData });
        const Component = yield import(/* webpackChunkName: "HigherFanFeedModule--Component" */ './HigherFanFeedModule');
        const render = () => {
            ReactDOM.render(React.createElement(Component.default, moduleProps), reactRoot);
            return reactRoot;
        };
        return {
            render,
        };
    }
    catch (error) {
        log.debug('HigherFanFeedModule error', error);
    }
    return null;
});
